import { func, number, shape, string } from 'prop-types'
import { Component } from 'react'
import { connectRange } from 'react-instantsearch-dom'

import { subscribe } from 'shared/store'
import { PRODUCT_FILTER_RESET } from 'shared/store/ducks/events'
import StarRatingSlider from 'views/components/molecules/StarRatingSlider'
import { AVERAGE_RATING_DEFAULT_VALUES } from 'views/components/organisms/AlgoliaInstantSearch/ProductFilter/consts'
import Collapsible from 'views/components/organisms/Collapsible'

import { getRealMaxForRatings, getRealMinForRatings } from './helpers'

class StarRatingSliderConnected extends Component {
  constructor(props) {
    super(props)

    const { minValue, maxValue } = props.defaultValues

    this.state = {
      values: [minValue, maxValue],
      currentRefinement: props.currentRefinement,
      refine: props.refine,
    }
  }

  componentDidMount() {
    const { minValue, maxValue } = this.props.defaultValues

    subscribe.after(PRODUCT_FILTER_RESET, () => {
      this.setState({
        values: [minValue, maxValue],
      })
    })
  }

  update({ min, max }) {
    const { refine } = this.state

    refine({
      min: getRealMinForRatings(min),
      max: getRealMaxForRatings(max),
    })
  }

  onValuesUpdated = ({ values: [min, max] }) => {
    this.setState({ values: [min, max] })
  }

  onSliderDragEnd = () => {
    const {
      currentRefinement,
      values: [min, max],
    } = this.state

    if (currentRefinement.min !== min || currentRefinement.max !== max) {
      this.update({ min, max })
    }
  }

  onStarClick = (value, isMin) => {
    const {
      currentRefinement,
      values: [min, max],
    } = this.state

    let newMin = isMin ? value : min
    let newMax = !isMin ? value : max

    if (isMin && value > max) {
      newMax = value
    }

    if (!isMin && value < min) {
      newMin = value
    }

    if (currentRefinement.min !== newMin || currentRefinement.max !== newMax) {
      this.setState({ values: [newMin, newMax] })
      this.update({ min: newMin, max: newMax })
    }
  }

  render() {
    const { label, attribute, ...starRatingSliderProps } = this.props
    const { values } = this.state

    return (
      <Collapsible
        id={`input-range-control-${attribute}`}
        label={label}
        expanded
        inFilter
        headingLevel="p"
        forceDisplayWhenCollapsed
      >
        <StarRatingSlider
          {...starRatingSliderProps}
          min={AVERAGE_RATING_DEFAULT_VALUES.min}
          max={AVERAGE_RATING_DEFAULT_VALUES.max}
          values={values}
          onValuesUpdated={this.onValuesUpdated}
          onSliderDragEnd={this.onSliderDragEnd}
          onStarClick={this.onStarClick}
        />
      </Collapsible>
    )
  }
}

StarRatingSliderConnected.propTypes = {
  ...StarRatingSlider.propTypes,
  label: string.isRequired,
  attribute: string.isRequired,
  currentRefinement: shape({}).isRequired,
  refine: func.isRequired,
  defaultValues: shape({
    minValue: number,
    maxValue: number,
  }),
}

StarRatingSliderConnected.defaultProps = {
  ...StarRatingSlider.defaultProps,
  defaultValues: {
    minValue: AVERAGE_RATING_DEFAULT_VALUES.min,
    maxValue: AVERAGE_RATING_DEFAULT_VALUES.max,
  },
}

export default connectRange(StarRatingSliderConnected)
